/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseOralExamHandshakeCanaryResponseData } from './genericApiResponseOralExamHandshakeCanaryResponseData';
import type { GenericApiResponseOralExamHandshakeCanaryResponseMessage } from './genericApiResponseOralExamHandshakeCanaryResponseMessage';
import type { GenericApiResponseOralExamHandshakeCanaryResponsePagination } from './genericApiResponseOralExamHandshakeCanaryResponsePagination';
import type { GenericApiResponseOralExamHandshakeCanaryResponseError } from './genericApiResponseOralExamHandshakeCanaryResponseError';

export interface GenericApiResponseOralExamHandshakeCanaryResponse {
  data?: GenericApiResponseOralExamHandshakeCanaryResponseData;
  message?: GenericApiResponseOralExamHandshakeCanaryResponseMessage;
  pagination?: GenericApiResponseOralExamHandshakeCanaryResponsePagination;
  error?: GenericApiResponseOralExamHandshakeCanaryResponseError;
  statusCode?: number;
}
